// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"b2bb6495","708":"36549e7b","710":"1c1fd1a9","799":"0ef94a5a"}[chunkId] + ".chunk.js";
};